import {
  ChangeEvent,
  KeyboardEvent,
  SyntheticEvent,
  useEffect,
  useState
} from 'react'

import { HeightClass } from '~/utils/enum/classes'
import { InputContainer, StyledInput } from './styles'

interface PageValueEditableProps {
  first: number
  current: number
  total: number
  onSubmit?: (n: number) => void
  heightClass: HeightClass
}

type Actions = {
  [key: string]: () => void
}

const isValidValue = (value: string, min: number, max: number) => {
  const isOnlyNumerals = new RegExp('^[0-9]+$').test(value)

  return isOnlyNumerals && +value >= min && +value <= max
}

const padNumber = (n: string) => n.padStart(2, '0')

const CurrentValueEditable = ({
  first,
  current,
  total,
  onSubmit,
  heightClass
}: PageValueEditableProps) => {
  const [value, setValue] = useState<string>(`${current}`)

  useEffect(() => setValue(`${current}`), [current])

  const handleOnChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const newValue = target.value.replace(new RegExp('^0+', 'g'), '')
    if (
      newValue.charAt(0) !== '0' &&
      (newValue === '' || isValidValue(newValue, first, total))
    ) {
      setValue(newValue)
    }
  }

  const handleKeyDown = ({ key }: KeyboardEvent<HTMLInputElement>) => {
    const actions: Actions = {
      ArrowUp: () => +value < total && setValue(`${+value + 1}`),
      ArrowDown: () => +value > first && setValue(`${+value - 1}`)
    }

    actions[key]?.()
  }

  const handleOnSubmit = (event: SyntheticEvent) => {
    event.preventDefault()

    if (onSubmit && isValidValue(value, first, total)) {
      onSubmit(+value)
    }
  }

  const handleOnBlur = () => {
    setValue(`${current}`)
  }

  return (
    <form onSubmit={handleOnSubmit} onBlur={handleOnBlur}>
      <InputContainer>
        <StyledInput
          value={padNumber(value)}
          onChange={handleOnChange}
          onKeyDown={handleKeyDown}
          heightClass={heightClass}
        />
      </InputContainer>
    </form>
  )
}

export default CurrentValueEditable
